import React from 'react';
import Anime from 'react-anime';
import { isMobile } from 'react-device-detect';
import './PhaseOneAnimation.scss';
export default ({ isActive, onHandleOpenModal }) => {
  const moveBall = {
    translateY: [
      { value: '-100vh', duration: 0},
      { value: () => isMobile ? '30vh' : '25vh', duration: 2000, easing: 'easeInSine'},
    ],
    translateX: [
      { value: 0, duration: 0},
      { value: '110vh', duration: 3000, easing: 'easeOutSine', delay: 2000},
    ]
  }
  const pulsateBall = {
    scale: [
      { value: .8, duration: 1000, easing: 'linear'},
      { value: 1.2, duration: 1000, easing: 'linear'},
    ],
    loop: true,
    direction: 'alternate'
  }
  return (
    <div className={`phase-one-animation`}>

      <div className={`pipe main-pipe empty`}>
        {isActive && (
          <Anime {...moveBall} className="ball">
            <div></div>
          </Anime>
        )}
      </div>
      <div className="single-tools-pipe">
    <Anime {...pulsateBall} className="outer-circle pulsating" >
      <div>
        <div className="inner-bubble" onClick={() => onHandleOpenModal(0)}>
          <div className="inner-bubble-mask"></div>
          <p>Behind the Scenes</p>
        </div>
      </div>
    </Anime>
      </div>
    </div>
  );
}